import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { isBrowser } from '../features.js';
var getNow = function getNow() {
  return Math.floor(Date.now() / 1000);
};
var RenewOnTabActivationService = /*#__PURE__*/function () {
  function RenewOnTabActivationService(tokenManager) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, RenewOnTabActivationService);
    this.started = false;
    this.lastHidden = -1;
    this.tokenManager = tokenManager;
    this.options = options;
    this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
  }
  return _createClass(RenewOnTabActivationService, [{
    key: "_onPageVisbilityChange",
    value: function _onPageVisbilityChange() {
      if (document.hidden) {
        this.lastHidden = getNow();
      } else if (this.lastHidden > 0 && getNow() - this.lastHidden >= this.options.tabInactivityDuration) {
        var _this$tokenManager$ge = this.tokenManager.getTokensSync(),
          accessToken = _this$tokenManager$ge.accessToken,
          idToken = _this$tokenManager$ge.idToken;
        if (!!accessToken && this.tokenManager.hasExpired(accessToken)) {
          var key = this.tokenManager.getStorageKeyByType('accessToken');
          this.tokenManager.renew(key).catch(function () {});
        } else if (!!idToken && this.tokenManager.hasExpired(idToken)) {
          var _key = this.tokenManager.getStorageKeyByType('idToken');
          this.tokenManager.renew(_key).catch(function () {});
        }
      }
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.canStart() && !!document) {
                document.addEventListener('visibilitychange', this.onPageVisbilityChange);
                this.started = true;
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (document) {
                document.removeEventListener('visibilitychange', this.onPageVisbilityChange);
                this.started = false;
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "canStart",
    value: function canStart() {
      return isBrowser() && !!this.options.autoRenew && !!this.options.renewOnTabActivation && !this.started;
    }
  }, {
    key: "requiresLeadership",
    value: function requiresLeadership() {
      return false;
    }
  }, {
    key: "isStarted",
    value: function isStarted() {
      return this.started;
    }
  }]);
}();
export { RenewOnTabActivationService };